import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h9v4ts3nzb: FaireBrandEntity = {
  token: "b_h9v4ts3nzb",
  type: "brand",
  name: "Neurogan Health",
  avatarUrl:
    "https://cdn.faire.com/fastly/41f587a928f60874a061052221dc3a9f54076f4c8dc237b02168e4d7f7a4d8fb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1bd3b15089827ad915767b80d477128f382ad86ce0c02b49e95e7c30479f8393.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/41f587a928f60874a061052221dc3a9f54076f4c8dc237b02168e4d7f7a4d8fb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1bd3b15089827ad915767b80d477128f382ad86ce0c02b49e95e7c30479f8393.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "Neurogan Health began with our founder, Jan Brandrup, who wanted people to feel better, stay sharp & slow down age-related decline. In his 50s, he noticed drops in sleep quality, energy, and focus. Changing his diet and training was not enough. That pushed him back to researchers at a university in Denmark, where he learned how much DNA and cellular function shape the way we age.\n\nHe teamed up with his sons and started Neurogan Health with one goal. Build high potent, science-driven longevity supplements that do not cut corners.\n\nWhat started as a solution for current issues has grown into a mission to slow future ones. Today the lineup includes NMN, NAD, Urolithin A, spermidine, fisetin, and more. These are strong sellers that match what customers want.\n\nNeurogan Health is built for people who care about performance, long-term health, and staying active. These benefits reflect what they are looking for:\n\n• Supports natural energy\n• Healthy Aging & cellular repair\n• Boosts Brain Health and focus\n• Promotes Autophagy\n• Strengthens immune defense\n• Supports heart and metabolic health\n\nIf you choose to partner with Neurogan Health private white label division, you get more than a supplier. You get access to the newest supplements, peptides, and functional skin care products that are driving demand.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:02.240Z",
    importedBy: "entity-db-cli",
  },
};
